import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { REPORT_TYPE, REPORT_ALIGNMENT } from './utility-model';


declare var Stimulsoft: any;
@Injectable()
export class UtilityReport {

  private EMPTY_SPACE = ' ';

  constructor(
    private datePipe: DatePipe,
    private translate: TranslateService,
  ) {}

  getDataText(type: REPORT_TYPE, field: any): any {
    switch (type) {
      case REPORT_TYPE.DATE: {
        return field ? this.datePipe.transform(field, 'yyyy-MM-dd') : this.EMPTY_SPACE;
      }
      case REPORT_TYPE.TIME: {
         return field ? field.slice(0, 8) : this.EMPTY_SPACE;
      }
      case REPORT_TYPE.DATE_TIME: {
        return field ? this.datePipe.transform(field, 'yyyy-MM-dd HH:mm') : this.EMPTY_SPACE;
      }
      case REPORT_TYPE.STANDARD:
      default: {
        return field ? field.toString() : this.EMPTY_SPACE;
      }
    }
  }

  getHorAlignment(alignment: string): any {
    switch (alignment) {
      case REPORT_ALIGNMENT.LEFT: {
        return Stimulsoft.Base.Drawing.StiTextHorAlignment.Left;
      }
      case REPORT_ALIGNMENT.RIGHT: {
        return Stimulsoft.Base.Drawing.StiTextHorAlignment.Right;
      }
      case REPORT_ALIGNMENT.CENTER:
      default: {
        return Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kontable/utility/utility-report.ts